import { motion } from 'framer-motion';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Alert } from '../../Alert/src/Alert.js';
import { EASINGS } from '../../Transition/src/_utils.js';
import '../../Transition/src/Fade.js';
import '../../Transition/src/ScaleFade.js';
import '../../Transition/src/SlideFade.js';
import '../../Transition/src/Collapse.js';
import modules_2b902d32 from '../styles/Notifications.module.less.js';

/**
 * @description Notification component.
 *
 * @component
 * @example
 * ```jsx
 * <Notification />
 * ```
 */
const Notification = React.memo((props) => {
    const { id, type, title, subtitle, message, closable = true, onClose } = props;
    const cx = useStyles(modules_2b902d32);
    const alertClassNames = cx('alert', {
        [`type-${type}`]: type,
    });
    const alertMotionProps = React.useMemo(() => ({
        variants: {
            exit: {
                opacity: 0,
                x: 400,
                height: 0,
                transition: {
                    x: { duration: 0.1, ease: EASINGS.easeOut },
                    height: { delay: 0.1, duration: 0.1 },
                    duration: 0.2,
                    ease: EASINGS.easeOut,
                },
            },
            enter: {
                opacity: 1,
                height: 'auto',
                x: 0,
                transition: {
                    height: { duration: 0.1 },
                    x: { delay: 0.1, ease: EASINGS.easeInOut },
                    duration: 0.25,
                    delay: 0.2,
                    ease: EASINGS.easeInOut,
                },
            },
        },
        initial: 'exit',
        animate: 'enter',
        exit: 'exit',
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 30,
            mass: 0.2,
        },
        drag: 'x',
        draggable: true,
        dragElastic: 0.2,
        dragConstraints: { left: 0, right: 400 },
    }), []);
    const handleClickClose = React.useCallback(() => {
        onClose(id);
    }, [id, onClose]);
    const handleDragEnd = React.useCallback((_, { offset, velocity }) => {
        if (Math.abs(offset.x) * velocity.x > 0) {
            onClose(id);
        }
    }, [id, onClose]);
    const MotionComponent = motion(Alert);
    return (React.createElement(MotionComponent, { ...alertMotionProps, className: alertClassNames, title: title, subtitle: subtitle, closable: closable, onClose: handleClickClose, 
        // @ts-ignore
        onDragEnd: handleDragEnd }, message));
});
Notification.displayName = 'Notification';

export { Notification };
//# sourceMappingURL=Notification.js.map
